<!--首页-->
<template>
  <div class="home-box cr">
    <div class="head-box flex ac jc"  :style="{backgroundImage: 'url(' + banner + ')', backgroundRepeat:'no-repeat'}">
      <div class="head-btn1" @click="handleJump('/create')">
        + 创建视频
      </div>
      <div class="head-btn2" @click="handleJump('/profile')">
        定制数字演员
      </div>
    </div>
    <div class="my-works" ref="scrollContainer" @scroll="handleScroll">
      <div class="select-box" :style="{ backgroundColor: theme.layout1 }">
        <div class="flex ac jb">
          <div class="flex ac">
            <div class="pp1" :style="{ color: titleState==1 ? theme.homeColor1 : theme.homeColor2}"  @click="handleChoose(1)">公共演员</div>
            <div class="pp1" :style="{ color: titleState==2 ? theme.homeColor1 : theme.homeColor2}" @click="handleChoose(2)">公共配音</div>
          </div>
          <div class="hs-box flex ac" v-if="titleState==1" :style="{ backgroundColor: theme.homeColor6 }">
            <div class="normal" :style="{ color: hsState==1? theme.homeColor3 : theme.homeColor4, backgroundColor: hsState==1 ? theme.homeColor5 : theme.homeColor6}"  @click="handleHs(1)">横版</div>
            <div class="normal" :style="{ color: hsState==2? theme.homeColor3 : theme.homeColor4, backgroundColor: hsState==2 ? theme.homeColor5 : theme.homeColor6}" @click="handleHs(2)">竖版</div>
          </div>
        </div>
      </div>
      <div v-if="titleState==1">
        <div class="flex ac fw" v-if="hsState==2">
          <div class="every-video-s" @mouseover="handleMouse(item)" @mouseleave="handleMouseOut"
               v-for="(item,index) in workList" :key="item.id || index">
            <img :src="item.cover_small" alt="cover">
            <p class="pp3 fs15 te">{{item.name}}</p>
            <div v-if="hoverId==item.id">
              <div class="head-btn1 btn1-top" @click="handlePlay(item)">
                播放视频
              </div>
              <div class="head-btn1 btn2-top" @click="handleJump3(item)">
                + 创建视频
              </div>
            </div>
          </div>
        </div>

        <div class="flex ac fw" v-if="hsState==1">
          <div class="every-video-h" @mouseover="handleMouse(item)" @mouseleave="handleMouseOut"
               v-for="(item,index) in workList" :key="item.id || index">
            <img :src="item.cover_small" alt="cover">
            <p class="pp3 fs15 te">{{item.name}}</p>
            <div v-if="hoverId==item.id">
              <div class="head-btn1 btn1-top" @click="handlePlay(item)">
                播放视频
              </div>
              <div class="head-btn1 btn2-top" @click="handleJump3(item)">
                + 创建视频
              </div>
            </div>
          </div>
        </div>

        <!-- 加载状态 -->
        <div class="loading-container" v-if="loading">
          <div class="loading-spinner"></div>
          <p class="loading-text">加载中...</p>
        </div>

        <!-- 没有更多数据提示 -->
        <div class="no-more-container" v-if="noMore && workList.length > 0">
          <p class="no-more-text">没有更多数据了</p>
        </div>
      </div>
      <div class="voice-ku" v-if="titleState==2">
        <div class="flex ac fw">
          <div class="every-voice flex ac" v-for="(item,index) in voiceArray" :key="item.id || index" :style="{ backgroundColor: theme.homeColor10, borderColor:theme.homeColor7 }">
            <div class="card-img" @mouseover="handleMouse2(item)" @mouseleave="handleMouseOut2"
                 @click="handlePlay2(item)">
              <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
              <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
                <div class="play-pause-btn">
                  <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                     style="color: #ffffff;font-size: 25px"></i>
                  <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                  <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                       src="../assets/pcImages/voice-playing.gif">
                </div>
              </div>
            </div>
            <div>
              <p class="pp4 te" :style="{ color: theme.homeColor8 }">{{item.name}}</p>
              <p class="pp5" :style="{ color: theme.homeColor9 }">{{site_title}}高保真音频</p>
            </div>
          </div>
        </div>
      </div>

      <div class="beian-box fs11 flex ac jc" :style="{ color: theme.layout7 }">
        <div class="mr05" v-if="icp" @click="goBeian">
          <span>{{icp}}</span>
        </div>
        <div class="mr05 flex ac" v-if="gabeian">
          <img src="../assets/images/gonganbeihao.png" alt="">
          <div v-html="gabeian"></div>
        </div>
        <div class="mr05" v-if="copyright">
          <div v-html="copyright"></div>
        </div>
        <div class="" v-if="diy_label">
          <div v-html="diy_label"></div>
        </div>
      </div>

    </div>
    <el-dialog
      :title="videoName"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleDialogClose"
    >
      <div class="dialog-video">
        <video ref="videoPlayer" style="width: 100%;height: 100%" controls="" autoplay="" :src="videoUrl"></video>
      </div>
    </el-dialog>
    <audio
      style="width: 1px;height: 1px;opacity: 0;position: fixed;right: 0;bottom: 0"
      ref="audioPlayer"
      @ended="audioEnded"
      :src="audioSrc"
      controls></audio>
  </div>
</template>
<script>
  import {delWorks, getIndexVideo, getVoice, site,} from '../api/user'

  export default {
    name: '',
    data() {
      return {
        options: [{
          value: '0',
          label: '全部'
        }, {
          value: '2',
          label: '生成中'
        }, {
          value: '3',
          label: '生成成功'
        }, {
          value: '4',
          label: '生成失败'
        }],
        value: '',
        input2: '',
        autoState: false,
        workList: [],
        selectObj: {
          source: '2', page: 1, limit: 20, name: ''
        },
        hoverId: '',
        dialogVisible: false,
        videoName: '',
        videoUrl: '',
        titleState: 1,
        hsState: 2,
        voiceArray: [],
        mouseState: false,
        palyState: 1,
        audioSrc: '',
        clickId: false,
        site_title: '',
        banner: '',

        icp: '',
        gabeian: '',
        copyright: '',
        cert: '',
        safety_cert: '',
        diy_label: '',

        // 滚动分页相关状态
        loading: false,
        noMore: false,
        total: 0,
        pageSize: 20
      }
    },
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    created() {
      this.getWorksList()
      this.getVoiceList()
      this.getSite()
    },
    methods: {
      goBeian(){
        window.open('https://beian.miit.gov.cn/', '_blank');
      },
      // 获取配置
      getSite() {
        site().then(res => {
          this.site_title = res.data.site_title ? res.data.site_title : 'AI超级分身'
          this.banner = res.data.banner ?  res.data.banner : 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/international/1.1_Banner_zh.png'
          const regex = new RegExp('<img', 'gi')
          this.icp = res.data.icp
          this.gabeian = res.data.gabeian
          this.copyright = res.data.copyright
          this.diy_label = res.data.diy_label ? res.data.diy_label.replace(regex, `<img style="max-height: 20px"`) : ''
        })
      },
      handleChoose(val) {
        this.titleState = val
        // 切换标签时重置分页状态
        if (val === 1) {
          this.resetPagination()
          this.getWorksList()
        }
      },
      handleHs(val) {
        // 如果点击的是当前已选中的状态，不做任何操作
        if (this.hsState === val) {
          return
        }

        this.hsState = val
        this.resetPagination()

        // 添加延迟确保状态更新完成
        this.$nextTick(() => {
          this.getWorksList()
        })
      },
      handleMouse(item) {
        this.hoverId = item.id
      },
      select() {
        this.resetPagination()
        this.getWorksList()
      },
      handleMouseOut() {
        this.hoverId = ''
      },
      handleJump(val) {
        this.$router.push(val)
      },
      handleJump2() {
        this.$router.push({
          path: '/clone',
          query: {
            id: 2
          }
        })
      },
      handleJump3(item) {
        this.$router.push({
          path: '/create',
          query: {
            id: item.id,
            hs: this.hsState
          }
        })
      },

      // 重置分页状态
      resetPagination() {
        this.workList = []
        this.selectObj.page = 1
        this.selectObj.limit = 20 // 重置为默认的limit值
        this.loading = false
        this.noMore = false
        this.total = 0
      },

      // 滚动事件处理
      handleScroll() {
        if (this.titleState !== 1 || this.loading || this.noMore) {
          return
        }

        const container = this.$refs.scrollContainer
        if (!container) return

        const { scrollTop, scrollHeight, clientHeight } = container
        // 当滚动到距离底部100px时触发加载
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          this.loadMore()
        }
      },

      // 加载更多数据
      loadMore() {
        if (this.loading || this.noMore) return

        this.loading = true
        this.selectObj.page += 1

        getIndexVideo({...this.selectObj}).then(res => {
          this.loading = false

          let newList = []
          if (this.hsState == 1) {
            newList = res.data.hlist || []
          } else {
            newList = res.data.slist || []
          }

          if (newList.length === 0) {
            this.noMore = true
          } else {
            this.workList = [...this.workList, ...newList]
          }
        }).catch(() => {
          this.loading = false
          this.selectObj.page -= 1 // 请求失败时回退页码
        })
      },

      getWorksList() {
        this.loading = true

        getIndexVideo({...this.selectObj}).then(res => {
          this.loading = false

          // this.workList = res.data.list
          if (this.hsState == 1) {
            this.workList = res.data.hlist || []
          } else {
            this.workList = res.data.slist || []
          }

          // 判断是否还有更多数据
          if (this.workList.length < this.pageSize) {
            this.noMore = true
          }

          // 如果数据为空且是第一页，尝试使用更大的limit重新请求一次
          if (this.workList.length === 0 && this.selectObj.page === 1 && this.selectObj.limit === 20) {
            this.selectObj.limit = 9999 // 临时使用大数量
            this.getWorksList()
          } else if (this.workList.length === 0) {
            // 如果仍然为空，设置没有更多数据
            this.noMore = true
          }
        }).catch((error) => {
          this.loading = false
          console.error('获取数据失败:', error)

          // 请求失败时，如果是第一页且limit还是20，尝试使用更大的limit
          if (this.selectObj.page === 1 && this.selectObj.limit === 20) {
            this.selectObj.limit = 9999
            this.getWorksList()
          } else {
            // 如果已经尝试过更大的limit或者不是第一页，设置没有更多数据
            this.noMore = true
          }
        })
      },
      getVoiceList() {
        getVoice({source: '2', page: 1, limit: 9999}).then(res => {
          this.voiceArray = res.data.list
        })
      },
      handlePlay(item) {
        this.videoName = item.name
        this.videoUrl = item.url
        this.dialogVisible = true
      },
      handleDialogClose() {
        // 停止视频播放
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
        }
      },

      handleMouse2(item) {
        this.mouseState = true
        this.hoverId = item.id
      },
      handleMouseOut2() {
        if (this.palyState != 3) {
          this.mouseState = false
        }
      },
      handlePlay2(item) {
        this.mouseState = true
        this.clickId = item.id
        if (this.palyState == 1) {
          this.palyState = 3
          this.audioSrc = item.url
          this.$nextTick(() => {
            const audio = this.$refs.audioPlayer
            audio.load()
            audio.play()
          })
        } else if (this.palyState == 3) {
          this.palyState = 1
          this.$refs.audioPlayer.pause()
        }
      },
      audioEnded() {
        this.palyState = 1
      },


      downVideo(item) {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', item.url, true)
        // xhr.open('GET', require('../../assets/images/test.mp4'), true)
        xhr.responseType = 'blob' // 返回类型blob
        // 监听进度
        xhr.onprogress = function (e) {
          if (e.lengthComputable) {
            // 文件总体积
            console.log(e.total)
            // 已下载体积
            console.log(e.loaded)
          }
        }
        xhr.onload = function () {
          this.show = false
          if (xhr.readyState === 4 && xhr.status === 200) {
            const blob = this.response
            // 转换一个blob链接
            const u = window.URL.createObjectURL(new Blob([blob]))
            const a = document.createElement('a')
            // a.download = '1344.mp4'
            var str = ''
            str = new Date().getTime() + '.mp4'
            a.download = str
            a.href = u
            // a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            // a.remove();
            // 释放
            console.log('结束')
            window.URL.revokeObjectURL(u)
          } else {
            console.log('失败了')
          }
        }
        xhr.onerror = function () {
          console.log('下载失败')
        }
        xhr.send()
      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style scoped lang="scss">
  p {
    margin: 0;
    padding: 0;
  }

  .home-box {
    font-size: 18px;
    cursor: pointer;
    padding: 28px 40px 0 40px;

    .head-box {
      width: 1640px;
      height: 240px;
      /*background: url("../assets/pcImages/1.1_Banner@2x.png") no-repeat;*/
      background-size: 100% 100%;
      padding-top: 142px;

      .head-btn1 {
        font-weight: 600;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 44px;
        text-align: center;
        width: 144px;
        height: 44px;
        background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
        border-radius: 8px;
        margin-right: 16px;
      }

      .head-btn2 {
        font-weight: 600;
        font-size: 16px;
        color: #08ECF6;
        line-height: 44px;
        text-align: center;
        width: 144px;
        height: 44px;
        border-radius: 8px !important;
        border: 1px solid;
      }
    }

    .my-works::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    .my-works {
      box-sizing: border-box;
      /*padding: 0 24px 24px 24px;*/
      /*background: #ffffff;*/
      border-radius: 10px;
      height: calc(100vh - 80px - 190px - 95px);
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: none !important; /* Firefox */
      -ms-overflow-style: none !important; /* IE 10+ */

      .select-box {
        padding: 15px 0;
        height: 80px;
        width: 100%;
        position: sticky;
        top: 0;
        z-index: 999;
        /*background: #0D1027;*/

        .pp1 {
          font-weight: 500;
          line-height: 60px;
          font-size: 16px;
          color: #EEEEEE;
          margin-right: 16px;
        }

        .pp1-active {
          color: #01FBF5 !important;
        }

        .hs-box {
          width: 90px;
          height: 28px;
          background: #0E1126;
          border-radius: 6px;
          border: 1px solid rgba(255, 255, 255, 0.15);

          .normal {
            width: 44px;
            height: 24px;
            border-radius: 4px;
            text-align: center;
            font-weight: 400;
            font-size: 12px;
            color: #FAFAFAAA;
            line-height: 24px;
          }

          .hs-active {
            background: #6C14FF;
            border-radius: 4px;
            color: #ffffff;
          }
        }
      }

      .every-video-s {
        position: relative;
        margin: 0 36px 36px 0;

        img {
          width: 243px;
          height: 432px;
          border-radius: 16px;
        }

        .head-btn1 {
          position: absolute;
          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 28px;
          text-align: center;
          width: 96px;
          height: 28px;
          background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
          border-radius: 4px;
          margin-right: 16px;
        }

        .btn1-top {
          left: 25px;
          bottom: 55px;
        }

        .btn2-top {
          left: 130px;
          bottom: 55px;
        }

        .pp3 {
          width: 243px;
          text-align: center;
          margin-top: 16px;
        }

      }

      .every-video-s:nth-child(6n) {
        margin: 0 0 36px 0 !important;
      }

      .every-video-h {
        position: relative;
        margin: 0 22px 36px 0;

        img {
          width: 308px;
          height: 174px;
          background: #2C2C2C;
          border-radius: 16px;
          object-fit: contain;
        }

        .head-btn1 {
          position: absolute;
          left: 80px;
          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 28px;
          text-align: center;
          width: 96px;
          height: 28px;
          background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
          border-radius: 8px;
          margin-right: 16px;
        }

        .btn1-top {
          left: 55px;
          bottom: 55px;
        }

        .btn2-top {
          left: 170px;
          bottom: 55px;
        }

        .pp3 {
          width: 243px;
          text-align: center;
          margin-top: 16px;
        }
      }

      .every-video-h:nth-child(5n) {
        margin: 0 0 36px 0 !important;
      }

      // 加载状态样式
      .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px 0;

        .loading-spinner {
          width: 30px;
          height: 30px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #6C14FF;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 10px;
        }

        .loading-text {
          font-size: 14px;
          color: #999;
        }
      }

      .no-more-container {
        text-align: center;
        padding: 20px 0;

        .no-more-text {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .dialog-video {
    width: 100%;
    height: 440px;
  }

  .voice-ku {
    .pp1 {
      font-size: 16px;
      line-height: 1;
      color: #091221;
      font-weight: 500;
      margin-bottom: 24px;

      span {
        font-size: 12px;
        margin-left: 8px;
        color: #888;
        letter-spacing: 1px;
      }
    }

    .every-voice {
      margin: 0 20px 24px 0;
      padding: 16px 18px;

      width: 392px;
      height: 80px;
      /*background: #24273C;*/
      border-radius: 8px;
      border: 1px solid;


      .card-img {
        position: relative;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;

        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
          border-radius: 50%;
        }

        .hover-box {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          text-align: center;
          background: rgba(0, 0, 0, .5);
          border-radius: 50%;
          cursor: pointer;
          justify-content: center;
          align-items: center;

          .play-pause-btn {
            margin-top: 10px;

            .playing-box {
              width: 30px;
              height: 18px;
            }
          }
        }
      }

      .pp4 {
        width: 295px;
        font-weight: 400;
        font-size: 16px;
        color: #FAFAFA;
        text-align: left;
        margin-bottom: 4px;
      }

      .pp5 {
        font-weight: 400;
        font-size: 12px;
        color: #FAFAFAAA;
        text-align: left;
      }

      .all-tags {
        .every-tag {
          font-size: 12px;
          color: #5b647a;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          font-weight: 400;
          background: #edeef7;
          border-radius: 4px;
          padding: 0 4px;
          white-space: nowrap;
          margin-right: 5px;
        }
      }
    }

    .every-voice:nth-child(4n) {
      margin: 0 0 24px 0 !important;
    }
  }
  .beian-box{
    font-size: 12px;
    position: fixed;
    bottom: 5px;
    text-align: center;
    width: 100%;
    height: 20px;
    img{
      margin-right: 4px;
      width: 16px;
      height: 16px;
    }
  }
</style>
<style>
  .home-box .el-input {
    width: 200px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/home.vue